import gql from 'graphql-tag';
export const StatFeatureHideNewEnquiryButtonFeature = gql `
    fragment StatFeatureHideNewEnquiryButtonFeature on InquiryFeatureSettingsFlags {
        hideNewEnquiryButton
    }
`;
